<template>
  <v-card color="transparent" elevation="0">
    <v-data-table
      :headers="headers"
      :items="storageCards"
      :search="search"
      :items-per-page="30"
      class="elevation-0 transparent"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat class="transparent">
          <v-toolbar-title>Skladové karty</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.foreignCard="props">
        <v-edit-dialog
          :return-value.sync="props.item.foreignCard"
          large
          persistent
          @save="save(props.item)"
          @cancel="cancel"
        >
          {{ props.item.foreignCard }}
          <v-icon small class="px-3">edit</v-icon>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.foreignCard"
              label="Edit"
              single-line
              counter
              v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##']"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active" :color="'success'" dark>check</v-icon>
        <v-icon v-else :color="'error'" dark>close</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { tableHeader, storageCardTypes } from "../js/storageCard";

export default {
  name: "StorageCardList",
  props: {
    storageCards: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    dialog: false,
    headers: tableHeader,
    storageCardTypes: storageCardTypes,
    search: ""
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    save(item) {
      this.openGlobalLoader("Ukladá sa ...");
      this.services
        .storageCardService()
        .putStorageCard(item)
        .then(() => {
          this.openGlobalAlert("Data boli uložené.", "success");
          this.$emit("refresh");
        })
        .catch(() => {
          this.openGlobalAlert("Chyba pri ukladaní!", "error");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    cancel() {
      this.openGlobalAlert("Zrušené", "warning");
    }
  }
};
</script>
